module.exports = __webpack_public_path__ + "static/media/arena2d.8ee6a6c5.png";